export default __webpack_public_path__ + "static/media/playstore.fec533ad.png";